import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { times } from "../../../../../../enums/times";
import { useFetch } from "../../../../../../hooks/useFetch";
import { useAppStore } from "../../../../../../stores/RootStore";
import { FShift } from "../../../../../../types/types";
import { Button } from "../../../../../../ui/Button";
import { Label } from "../../../../../../ui/Label/Label";
import { SelectButton } from "../../../../../../ui/SelectButton/SelectButton";

type Props = {
  itemId: string | undefined;
  refreshModels: Function;
  currentShift: FShift;
};

const AddModel = ({ itemId, refreshModels, currentShift }: Props) => {
  const { currentUser, currentSite } = useAppStore();
  const isRestricted = !currentUser?.attributes.admin && currentSite?.user_status == "user";

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      break_start: null,
      break_end: null,
    },
  });

  let newTimes: { value: string; label: string }[];
  const startShiftInSeconds = currentShift.start_at.toSeconds() - currentShift.start_at.startOf("day").toSeconds();
  const endShiftInSeconds = currentShift.end_at.toSeconds() - currentShift.end_at.startOf("day").toSeconds();
  const isNightShift = startShiftInSeconds > endShiftInSeconds ? true : false;
  if (!isNightShift) {
    newTimes = times.filter((time) => {
      const timeInSeconds =
        Number(time.value[0] + time.value[1]) * 60 * 60 + Number(time.value[3] + time.value[4]) * 60;
      if (timeInSeconds >= startShiftInSeconds && timeInSeconds <= endShiftInSeconds) return true;
      else return false;
    });
  } else {
    // Разбивка на два подмассива для сохранения порядка времен (от начала смены, до конца)
    const newTimes1 = times.filter((time) => {
      const timeInSeconds =
        Number(time.value[0] + time.value[1]) * 60 * 60 + Number(time.value[3] + time.value[4]) * 60;
      if (timeInSeconds >= startShiftInSeconds) return true;
      else return false;
    });
    const newTimes2 = times.filter((time) => {
      const timeInSeconds =
        Number(time.value[0] + time.value[1]) * 60 * 60 + Number(time.value[3] + time.value[4]) * 60;
      if (timeInSeconds <= endShiftInSeconds) return true;
      else return false;
    });
    newTimes = [...newTimes1, ...newTimes2];
  }

  const [{ response: modelSaveResponse, isLoading: modelSaveIsLoading, error: modelSaveError }, doFetchModelSave] =
    useFetch(`/directories/working_shifts/${itemId}/working_shift_breaks`);

  const onSubmit = (formData: any) => {
    doFetchModelSave({
      method: "POST",
      data: {
        data: {
          started_at: `${formData.break_start}:00`,
          ended_at: `${formData.break_end}:00`,
        },
      },
    });
  };

  useEffect(() => {
    if (modelSaveResponse) {
      reset();
      refreshModels();
    }
  }, [modelSaveResponse]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col w-full gap-1 bg-muted p-4 rounded">
        <div className="text-lg font-medium">{t("adding_break")}</div>
        <div className="text-sm">{t("adding_break_form_text")}</div>

        <div className="flex w-full items-end gap-4 mt-4">
          <div className="grid grid-cols-2 items-end w-full gap-4">
            <Controller
              name="break_start"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("break_start")}*</Label>
                  <SelectButton
                    disabled={isRestricted}
                    label={"Выберите время"}
                    searchable={true}
                    options={newTimes}
                    value={value ? newTimes.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            <Controller
              name="break_end"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative flex flex-col space-y-2">
                  <Label>{t("break_end")}*</Label>
                  <SelectButton
                    disabled={isRestricted}
                    label={"Выберите время"}
                    searchable={true}
                    options={newTimes}
                    value={value ? newTimes.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
          </div>

          <Button disabled={isRestricted} type="submit" size={"sm"}>
            {t("save")}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AddModel;
